module.exports = __webpack_public_path__ + "img/005-bebo.503b30e9.svg";